<template>
    <kt-row>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="pin">
                    {{ $t('label.pin') }}
                </kt-form-label>
                <kt-form-control
                        id="pin"
                        name="pin"
                        v-model="port_config.pin"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        form_data: {
            required: true
        },
        port_config: {
            required: true
        }
    },
}
</script>

<style>
</style>